import { forwardRef } from 'react';

import memoize from 'memoize-one';

import BaseRepositoryLink from 'src/components/repository-link';

// Memoized repo link to avoid rerenders
export const memoRepoLink = memoize(
  (
    name: string | undefined,
    fullName: string | undefined,
    landingPage: string | undefined,
    htmlUrl: string | undefined
  ) =>
    // Name the render function so it shows up in DevTools as `ForwardRef(RepositoryLink)` instead of just `ForwardRef`
    // @ts-ignore TODO: fix noImplicitAny error here
    forwardRef(function RepositoryLink(props, ref: (ReactNode) => void) {
      return (
        <BaseRepositoryLink
          {...props}
          innerRef={ref}
          repository={{
            name: name ?? '',
            landing_page: landingPage ?? '',
            full_name: fullName ?? '',
            links: { html: { href: htmlUrl ?? '' } },
          }}
        />
      );
    })
);
